import * as Immutable from 'immutable';
import Dimensions from '../../Utils/Dimensions';

export enum DocumentStatusTypes {
	New		= 'STATUS_NEW',
	Edit	= 'STATUS_EDIT',
	Saving	= 'STATUS_SAVING',
	Saved	= 'STATUS_SAVED',
}

export enum DocumentUnitTypes {
	Pixels = 'UNIT_TYPE_PIXELS',
	Inches = 'UNIT_TYPE_INCHES',
	Centimeters = 'UNIT_TYPE_CENTIMETERS',
}

export interface IDocumentStore {
	designId: number
	name: string
	offsetX: number
	offsetY: number
	width: number
	height: number
	dpi: number
	quality: number
	units: DocumentUnitTypes
	status: DocumentStatusTypes
	savedId: string
	lockRatio: boolean
	useChunks: boolean
	attachedModule?: string
}

let defaultWidth:number = 1200;
let defaultHeight:number = 1200;

const defaultStore = Immutable.Record<IDocumentStore>({
	designId: undefined,
	name: "Untitled",
	offsetX: 0,
	offsetY: 0,
	width: defaultWidth,
	height: defaultHeight,
	dpi: Dimensions.getMinDPI(defaultWidth, defaultHeight) + (Dimensions.getMaxDPI(defaultWidth, defaultHeight) - Dimensions.getMinDPI(defaultWidth, defaultHeight)) / 2,
	quality: 1,
	units: DocumentUnitTypes.Inches,
	status: DocumentStatusTypes.New,
	savedId: '',
	lockRatio: true,
	useChunks: false,
	attachedModule: undefined
});

export default class DocumentStore extends defaultStore implements IDocumentStore {}